export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14067.e61f1564.jpg";